import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { Subscription, timer } from 'rxjs';
import { SubscriptionHandlerService } from '../shared/services/subscription-handler.service';

@Component({
  selector: 'app-screensaver',
  templateUrl: './screensaver.component.html',
  styleUrls: ['./screensaver.component.scss'],
})
export class ScreensaverComponent implements OnInit, OnDestroy {
  isScreensaverActive = false;
  inactivityTime = 900000;
  private inactivityTimer?: Subscription;
  private componentName = 'ScreenSaver';

  constructor(private readonly subscriptionHandlerService: SubscriptionHandlerService) {}

  ngOnInit(): void {
    this.resetTimer();
  }

  ngOnDestroy(): void {
    this.clearTimer();
  }

  @HostListener('window:mousemove', ['$event'])
  @HostListener('window:keydown', ['$event'])
  @HostListener('window:click', ['$event'])
  onUserActivity(event: Event): void {
    event.preventDefault();
    this.resetTimer();
  }

  private resetTimer() {
    this.isScreensaverActive = false;
    this.clearTimer();

    const isPlayer = document.querySelector('app-player');

    this.inactivityTimer = timer(this.inactivityTime).subscribe(() => {
      this.isScreensaverActive = !isPlayer;
    });
    this.subscriptionHandlerService.addSubscription(this.componentName, 'inactivityTimer', this.inactivityTimer);
  }

  private clearTimer(): void {
    this.subscriptionHandlerService.unsubscribe(this.componentName, 'inactivityTimer');
    if (this.inactivityTimer) {
      this.inactivityTimer.unsubscribe();
      this.inactivityTimer = undefined;
    }
  }
}
